import { lazy } from 'react'
import { LANG } from "../language/lang";
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import QuizIcon from '@mui/icons-material/Quiz';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import CookieIcon from '@mui/icons-material/Cookie';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import FeedIcon from '@mui/icons-material/Feed';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';

const PublicLayout = lazy(() => import('../layouts/PublicLayout'))
const CabinetLayout = lazy(() => import('../layouts/CabinetLayout'))
const AuthLayout = lazy(() => import('../layouts/AuthLayout'))
const ProtectedRoute = lazy(() => import('../routers/ProtectedRoute'))

const Home = lazy(() => import('../pages/Home'))
const Login = lazy(() => import('../pages/Auth/Login'))
const NotFound = lazy(() => import('../pages/NotFound'))
const About = lazy(() => import('../pages/About'))
const Contacts = lazy(() => import('../pages/Contacts'))
const Registration = lazy(() => import('../pages/Auth/Registration'))
const Profile = lazy(() => import('../pages/Cabinet/Profile/index.js'))
const Orders = lazy(() => import('../pages/Cabinet/Orders/index.js'))
const Balance = lazy(() => import('../pages/Cabinet/Balance/index.js'))
const FAQ = lazy(() => import('../pages/FAQ'))
const Pages = lazy(() => import('../pages/Pages'))
const GameKey = lazy(() => import('../pages/GameKey'))
const GameCoin = lazy(() => import('../pages/GameCoin'))
const Search = lazy(() => import('../pages/Search'))
const Product = lazy(() => import('../pages/Product'))

const ROUTE = [
    {
        path: '/',
        component: <PublicLayout />,
        componentName: 'PublicLayout',
        children: [
            {
                index: true,
                component: <Home />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_HOME"),
                icon: <HomeIcon fontSize="small" />,
            },
            {
                path: 'game-key',
                component: <GameKey />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_GAME_KEY"),
                icon: <SportsEsportsIcon fontSize="small" />,
            },
            {
                path: 'game-coin',
                component: <GameCoin />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_GAME_COIN"),
                icon: <SportsSoccerIcon fontSize="small" />,
            },
            {
                path: 'about',
                component: <About />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_ABOUT"),
                icon: <InfoIcon fontSize="small" />,
            },
            
            {
                path: 'contacts',
                component: <Contacts />,
                menu: true,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_CONTACTS"),
                icon: <PermContactCalendarIcon fontSize="small" />,
            },

            {
                path: 'return-policy',
                component: <Pages />,
                menu: true,
                onlyMobile: true,
                secondary: true,
                title: LANG("MENU_RETURN_POLICY"),
                icon: <LocalAtmIcon fontSize="small" />,
            },

            {
                path: 'rules',
                component: <Pages />,
                menu: true,
                onlyMobile: true,
                secondary: true,
                title: LANG("MENU_RULES"),
                icon: <FeedIcon fontSize="small" />,
            },
            
            {
                path: 'cookie-policy',
                component: <Pages />,
                menu: true,
                onlyMobile: true,
                secondary: true,
                title: LANG("MENU_COOKIE_POLICY"),
                icon: <CookieIcon fontSize="small" />,
            },

        
            {
                path: 'privacy-policy',
                component: <Pages />,
                menu: true,
                onlyMobile: true,
                secondary: true,
                title: LANG("MENU_PRIVACY"),
                icon: <PrivacyTipIcon fontSize="small" />,
            },

            {
                path: 'search',
                component: <Search />,
                menu: false,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_SEARCH"),
            },

            {
                path: 'product',
                component: <Product />,
                menu: false,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_PRODUCT"),
            },

            {
                path: 'product/:id',
                component: <Product />,
                menu: false,
                onlyMobile: false,
                secondary: false,
                title: LANG("MENU_PRODUCT"),
            },
            

         

        ],
    },
    {
        path: '/auth',
        componentName: 'AuthLayout',
        component: <AuthLayout />,
        children: [
            {
                path: 'login',
                component: <Login />,
            },
            {
                path: 'registration',
                component: <Registration />,
            },
        ],
    },
    {
        path: '/cabinet',
        component: <ProtectedRoute />,
        componentName: 'ProtectedRoute',
        children: [
            {
                component: <CabinetLayout />,
                componentName: 'CabinetLayout',
                children: [
                    {
                        index: true,
                        component: <Profile />,
                    },
                    {
                        path: 'profile',
                        component: <Profile />,
                    },
                    {
                        path: 'orders',
                        component: <Orders />,
                    },
                    {
                        path: 'balance',
                        component: <Balance />,
                    },
                    
                ],
            },
        ],
    },
    {
        path: '*',
        component: <NotFound />,
    },
]

export default ROUTE